import { render, staticRenderFns } from "./Hamburger.vue?vue&type=template&id=ed20d8a6&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"
import style0 from "./Hamburger.vue?vue&type=style&index=0&id=ed20d8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed20d8a6",
  null
  
)

export default component.exports